import { TypeId, type as type$1, value as value$1, valueTags as valueTags$1, typeTags as typeTags$1, when as when$1, whenOr as whenOr$1, whenAnd as whenAnd$1, discriminator as discriminator$1, discriminatorStartsWith as discriminatorStartsWith$1, discriminators as discriminators$1, discriminatorsExhaustive as discriminatorsExhaustive$1, tag as tag$1, tagStartsWith as tagStartsWith$1, tags as tags$1, tagsExhaustive as tagsExhaustive$1, not as not$1, nonEmptyString as nonEmptyString$1, is as is$1, any as any$1, defined as defined$1, instanceOf as instanceOf$1, orElse as orElse$1, orElseAbsurd as orElseAbsurd$1, either as either$1, option as option$1, exhaustive as exhaustive$1 } from '../../internal/matcher.esm.js';
import { isString, isNumber, isBoolean, isUndefined, isNull, isBigInt, isDate, isRecord } from '../../Predicate/dist/effect-Predicate.esm.js';

/**
 * @since 1.0.0
 */
/**
 * @category type ids
 * @since 1.0.0
 */
const MatcherTypeId = TypeId;

/**
 * @category type ids
 * @since 1.0.0
 */

/**
 * @category model
 * @since 1.0.0
 */

/**
 * @category model
 * @since 1.0.0
 */

/**
 * @category model
 * @since 1.0.0
 */

/**
 * @category model
 * @since 1.0.0
 */

/**
 * @category model
 * @since 1.0.0
 */

/**
 * @category model
 * @since 1.0.0
 */

/**
 * @category constructors
 * @since 1.0.0
 */
const type = type$1;

/**
 * @category constructors
 * @since 1.0.0
 */
const value = value$1;

/**
 * @category constructors
 * @since 1.0.0
 */
const valueTags = valueTags$1;

/**
 * @category constructors
 * @since 1.0.0
 */
const typeTags = typeTags$1;

/**
 * @category combinators
 * @since 1.0.0
 */
const when = when$1;

/**
 * @category combinators
 * @since 1.0.0
 */
const whenOr = whenOr$1;

/**
 * @category combinators
 * @since 1.0.0
 */
const whenAnd = whenAnd$1;

/**
 * @category combinators
 * @since 1.0.0
 */
const discriminator = discriminator$1;

/**
 * @category combinators
 * @since 1.0.0
 */
const discriminatorStartsWith = discriminatorStartsWith$1;

/**
 * @category combinators
 * @since 1.0.0
 */
const discriminators = discriminators$1;

/**
 * @category combinators
 * @since 1.0.0
 */
const discriminatorsExhaustive = discriminatorsExhaustive$1;

/**
 * @category combinators
 * @since 1.0.0
 */
const tag = tag$1;

/**
 * @category combinators
 * @since 1.0.0
 */
const tagStartsWith = tagStartsWith$1;

/**
 * @category combinators
 * @since 1.0.0
 */
const tags = tags$1;

/**
 * @category combinators
 * @since 1.0.0
 */
const tagsExhaustive = tagsExhaustive$1;

/**
 * @category combinators
 * @since 1.0.0
 */
const not = not$1;

/**
 * @category predicates
 * @since 1.0.0
 */
const nonEmptyString = nonEmptyString$1;

/**
 * @category predicates
 * @since 1.0.0
 */
const is = is$1;

/**
 * @category predicates
 * @since 1.0.0
 */
const string = isString;

/**
 * @category predicates
 * @since 1.0.0
 */
const number = isNumber;

/**
 * @category predicates
 * @since 1.0.0
 */
const any = any$1;

/**
 * @category predicates
 * @since 1.0.0
 */
const defined = defined$1;

/**
 * @category predicates
 * @since 1.0.0
 */
const boolean = isBoolean;
const _undefined = isUndefined;
const _null = isNull;

/**
 * @category predicates
 * @since 1.0.0
 */
const bigint = isBigInt;

/**
 * @category predicates
 * @since 1.0.0
 */
const date = isDate;

/**
 * @category predicates
 * @since 1.0.0
 */
const record = isRecord;

/**
 * @category predicates
 * @since 1.0.0
 */
const instanceOf = instanceOf$1;

/**
 * @category predicates
 * @since 1.0.0
 */
const instanceOfUnsafe = instanceOf$1;

/**
 * @category conversions
 * @since 1.0.0
 */
const orElse = orElse$1;

/**
 * @category conversions
 * @since 1.0.0
 */
const orElseAbsurd = orElseAbsurd$1;

/**
 * @category conversions
 * @since 1.0.0
 */
const either = either$1;

/**
 * @category conversions
 * @since 1.0.0
 */
const option = option$1;

/**
 * @category conversions
 * @since 1.0.0
 */
const exhaustive = exhaustive$1;

/**
 * @since 1.0.0
 * @category type ids
 */
const SafeRefinementId = /*#__PURE__*/Symbol.for("./SafeRefinement");

/**
 * @since 1.0.0
 */

export { MatcherTypeId, SafeRefinementId, any, bigint, boolean, date, defined, discriminator, discriminatorStartsWith, discriminators, discriminatorsExhaustive, either, exhaustive, instanceOf, instanceOfUnsafe, is, nonEmptyString, not, _null as null, number, option, orElse, orElseAbsurd, record, string, tag, tagStartsWith, tags, tagsExhaustive, type, typeTags, _undefined as undefined, value, valueTags, when, whenAnd, whenOr };
